import React from "react";
import {
    Box,
    Button,
    SimpleGrid,
    Text,
    Flex,
    Spinner,
} from "@chakra-ui/react";
import { VideoCard } from "../../components/VideoCard";
import { ImageCard } from "../../components/ImageCard";
import { UploadResourceModal } from "../../components/UploadResourceModal";
import { FormSelect } from "../../components/FormSelect";
import { ModalBox } from "../../components/ModalBox";
import { UploadVideoModal } from "../../components/UploadVideoModal";
import { useResource } from "./useResource";
import { AudioCard } from "../../components/AudioCard";
import { PdfCard } from "../../components/PdfCard";
import { UploadingVideoCard } from "../../components/UploadingVideoCard";
import { HelmetComponent } from "../../components/HelmetComponent";
import NoDataMessage from "../../components/NoDataMessage";
import { PptCard } from "../../components/PptCard";

const filterTypes1 = [
    { id: "01", value: "images", name: "Images" },
    { id: "02", value: "videos", name: "Videos" },
    { id: "03", value: "audios", name: "Audios" },
    { id: "04", value: "pdfs", name: "PDFs" },
    { id: "05", value: "ppts", name: "PPts" },
]
const filterTypes2 = [
    { id: "01", value: "videos", name: "Videos" },
    { id: "02", value: "pdfs", name: "PDFs" },
]

export const ResourcesPage = ({ type = "images", isHideFilter = false, isHideUpload = false, isSelection=false, imageUrl, videoUrl, pdfUrl, audioUrl, pptUrl, selectMedia, isLogo = false, isFromContentPage = false, url }) => {

    const {
        loading,
        resources,
        filterType,
        deleteResourceRef,
        endOfListRef,
        deleting,
        deletingVimeoVideo,
        updateFilterType,
        isUploadOpen,
        onUploadOpen,
        onUploadClose,
        isVideoUploadOpen,
        onVideoUploadOpen,
        onVideoUploadClose,
        isDeleteModalOpen,
        onDeleteModelOpen,
        onDeletePopupClose,
        handleVideoUpload,
        handleDelete,
        user,
        publisher,
        isTokenExhaustOpen,
        onTokenExhaustOpen,
        onTokenExhaustClose,
        isTokenExhaustUpgradeToProOpen,
        onTokenExhaustUpgradeToProOpen,
        onTokenExhaustUpgradeToProClose,
        buyCredits,
        upgradeToPro,
    } = useResource({ type })

    return (
        <>
            <HelmetComponent title={`Gallery - Home - ${user.firstName} ${user.lastName}`}/>
            
            {/* Filter */}
            <Flex mb={4}
                sx={{
                    flexDirection: { base: "column", md: "row" },
                    alignItems: { base: "stretch", md: "center" },
                    justifyContent: "space-between",
                }}
            >
                {
                    !isHideFilter ?
                        <FormSelect
                            formProps={{
                                isRequired: true,
                                maxWidth: { base: "100%", md: "200px" },
                                margin: { base: "0 0 20px", md: "0 0 0" }
                            }}
                            label=""
                            value={filterType}
                            options={isFromContentPage ? filterTypes2 : filterTypes1}
                            name="filterType"
                            selectOnChange={updateFilterType}
                        /> : <Box visibility="hidden"></Box>
                }
                {
                    !isHideUpload && resources.length > 0 ? 
                    <Button 
                        colorScheme="blue" 
                        marginTop="20px" 
                        onClick={
                            publisher.creditsAvailable + publisher.extraCreditsAvailable > 0 ? () => {
                                if (filterType === "videos") {
                                    onVideoUploadOpen();
                                    return true;
                                }
                                onUploadOpen();
                            } : publisher.isPro ? onTokenExhaustOpen : onTokenExhaustUpgradeToProOpen
                        }
                    >
                        Upload
                    </Button> : <Box visibility="hidden"></Box>
                }
            </Flex>
            { loading ? 
                <Flex justifyContent="center" alignItems="center"><Spinner size="lg" mt={4} /></Flex> :
                resources.length === 0 ?
                <NoDataMessage 
                    title="No Resources Found" 
                    desc="Upload new resources to get started." 
                    buttonText="Upload" 
                    onClick={
                        publisher.creditsAvailable + publisher.extraCreditsAvailable > 0 ? () => {
                            if (filterType === "videos") {
                                onVideoUploadOpen();
                                return true;
                            }
                            onUploadOpen();
                        } : publisher.isPro ? onTokenExhaustOpen : onTokenExhaustUpgradeToProOpen
                    } 
                    filterType={filterType}
                /> : 
                    isFromContentPage ?
                        <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={6}>
                            {
                                resources.map(resource => {

                                    if (filterType === "pdfs" && resource.type === "application/pdf") {
                                        return (
                                            <PdfCard
                                                key={resource.key}
                                                pdf={resource}
                                                isHideDelete={true}
                                                isSelection={true}
                                                selectMedia={selectMedia}
                                                mediaUrl={url}
                                            />
                                        )
                                    }
                                    if (filterType === "videos" && resource.status === "available") {
                                        return (
                                            <VideoCard
                                                key={resource.id}
                                                video={resource}
                                                isHideDelete={true}
                                                isSelection={true}
                                                selectMedia={selectMedia}
                                                mediaUrl={url}
                                            />
                                        )
                                    }
                                    if (filterType === "videos" && resource.status === "uploading") {
                                        return (
                                            <UploadingVideoCard
                                                key={resource.id}
                                                video={resource}
                                                onDelete={() => {
                                                    deleteResourceRef.current = resource;
                                                    onDeleteModelOpen();
                                                }}
                                            />
                                        )
                                    }
                                })
                            }
                        </SimpleGrid> :
                    !isSelection ?
                        <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={6}>
                            {resources.map((resource) => {
                                if (filterType === "images" && resource?.url?.includes("images")) {
                                    return (
                                        <ImageCard
                                            key={resource.key}
                                            image={resource}
                                            onDelete={() => {
                                                deleteResourceRef.current = resource;
                                                onDeleteModelOpen();
                                            }}
                                        />
                                    )
                                }
                                if (filterType === "audios" && resource?.url?.includes("audios")) {
                                    return (
                                        <AudioCard
                                            key={resource.key}
                                            audio={resource}
                                            onDelete={() => {
                                                deleteResourceRef.current = resource;
                                                onDeleteModelOpen();
                                            }}
                                        />
                                    )
                                }
                                if (filterType === "pdfs" && resource.type === "application/pdf") {
                                    return (
                                        <PdfCard
                                            key={resource.key}
                                            pdf={resource}
                                            onDelete={() => {
                                                deleteResourceRef.current = resource;
                                                onDeleteModelOpen();
                                            }}
                                        />
                                    )
                                }
                                if (filterType === "videos" && resource.url.includes("vimeo") && resource.status === "available") {
                                    return (
                                        <VideoCard
                                            key={resource.id}
                                            video={resource}
                                            onDelete={() => {
                                                deleteResourceRef.current = resource;
                                                onDeleteModelOpen();
                                            }}
                                        />
                                    )
                                }
                                if (filterType === "videos" && resource.status === "uploading") {
                                    return (
                                        <UploadingVideoCard
                                            key={resource.id}
                                            video={resource}
                                            onDelete={() => {
                                                deleteResourceRef.current = resource;
                                                onDeleteModelOpen();
                                            }}
                                        />
                                    )
                                }
                                if (filterType === "ppts" && resource?.url?.includes("ppts")) {
                                    return (
                                        <PptCard
                                            key={resource.id}
                                            ppt={resource}
                                            onDelete={() => {
                                                deleteResourceRef.current = resource;
                                                onDeleteModelOpen();
                                            }}
                                        />
                                    )
                                }
                                return <></>
                            })}
                        </SimpleGrid> :
                        <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={6}>
                            {
                                resources.map(resource => {
                                    if (filterType === "images" && resource?.type?.startsWith("image/")) {
                                        return (
                                            <ImageCard
                                                key={resource.key}
                                                image={resource}
                                                isHideDelete={true}
                                                isSelection={true}
                                                selectMedia={selectMedia}
                                                mediaUrl={imageUrl}
                                            />
                                        )
                                    }
                                    if (filterType === "videos" && resource.status === "available") {
                                        return (
                                            <VideoCard
                                                key={resource.id}
                                                video={resource}
                                                isHideDelete={true}
                                                isSelection={true}
                                                selectMedia={selectMedia}
                                                mediaUrl={videoUrl}
                                            />
                                        )
                                    }
                                    if (filterType === "videos" && resource.status === "uploading") {
                                        return (
                                            <UploadingVideoCard
                                                key={resource.id}
                                                video={resource}
                                                onDelete={() => {
                                                    deleteResourceRef.current = resource;
                                                    onDeleteModelOpen();
                                                }}
                                            />
                                        )
                                    }
                                    if (filterType === "pdfs" && resource.type === "application/pdf") {
                                        return (
                                            <PdfCard
                                                key={resource.key}
                                                pdf={resource}
                                                isHideDelete={true}
                                                isSelection={true}
                                                selectMedia={selectMedia}
                                                mediaUrl={pdfUrl}
                                                showTooltip={true}
                                            />
                                        )
                                    }
                                    if (filterType === "audios" && resource?.type?.startsWith("audio/")) {
                                        return (
                                            <AudioCard
                                                key={resource.key}
                                                audio={resource}
                                                isHideDelete={true}
                                                isSelection={true}
                                                selectMedia={selectMedia}
                                                mediaUrl={audioUrl}
                                            />
                                        )
                                    }
                                    if (filterType === "ppts") {
                                        return (
                                            <PptCard
                                                key={resource.key}
                                                ppt={resource}
                                                isHideDelete={true}
                                                isSelection={true}
                                                selectMedia={selectMedia}
                                                mediaUrl={pptUrl}
                                                showTooltip={true}
                                            />
                                        )
                                    }
                                    return <></>
                                })
                            }
                        </SimpleGrid>
            }
            {/* End of List Detector */}
            <Box ref={endOfListRef} mt={4}></Box>
            <UploadResourceModal
                filterType={filterType}
                isOpen={isUploadOpen}
                onClose={onUploadClose}
                isLogo={isLogo}
            />
            <UploadVideoModal
                isOpen={isVideoUploadOpen}
                onCloseModal={onVideoUploadClose}
                handleUpload={handleVideoUpload}
            />
            <ModalBox
                title="Delete resource"
                description={
                    <Text fontSize="lg">
                        Are you sure you want to {deleteResourceRef?.current?.name}.
                    </Text>
                }
                isOpen={isDeleteModalOpen}
                onClose={onDeletePopupClose}
                isFooter={true}
                loadingText="Deleting"
                isWorking={deleting || deletingVimeoVideo}
                onCancel={onDeletePopupClose}
                onConfirm={handleDelete}
                cancelButtonText="Cancel"
                confirmButtonText="Delete"
                isDeleteButton={true}
            ></ModalBox>
            <ModalBox
                title="Credits"
                isOpen={isTokenExhaustOpen}
                onClose={onTokenExhaustClose}
                isFooter={true}
                onCancel={onTokenExhaustClose}
                confirmButtonType={true}
                onConfirm={buyCredits}
                isDeleteButton={false}
                confirmButtonText="Buy Credit"
                description={`You’ve used all your available credits.
                Please purchase additional credits to continue using this feature.`}
            />
            <ModalBox
                title="Upgrade"
                isOpen={isTokenExhaustUpgradeToProOpen}
                onClose={onTokenExhaustUpgradeToProClose}
                isFooter={true}
                onCancel={onTokenExhaustUpgradeToProClose}
                confirmButtonType={true}
                onConfirm={upgradeToPro}
                isDeleteButton={false}
                confirmButtonText="Upgrade To Pro"
                description={`You’ve used all your available credits.
                Please upgrade to Pro to continue using this feature.`}
            />
        </>
    );
};